import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '~/services/supabase';
import { SyncActivityLog } from '~/components/SyncActivityLog';
import { Button } from '~/components/ui/button';

export const FormLogs = () => {
  const { id } = useParams<{ id: string }>();
  const [formName, setFormName] = useState<string>('');

  useEffect(() => {
    if (!id) return;
    supabase
      .from('forms')
      .select('name')
      .eq('id', id)
      .single()
      .then(({ data }) => {
        if (data) setFormName(data.name);
      });
  }, [id]);

  if (!id) return null;

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" asChild>
          <Link to={`/forms/${id}`}>
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <h1 className="text-2xl font-bold">{formName ? `${formName} — Logs` : 'Logs'}</h1>
      </div>

      <SyncActivityLog formId={id} />
    </div>
  );
};
